import { LocaleEnum } from '@systemeio/ui'

export const getPaypalHelpPageLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DUTCH: {
      return 'https://help-nl.systeme.io/article/1428-hoe-integreer-je-paypal-met-systeme'
    }
    case LocaleEnum.DEUTSCH: {
      return 'https://help-de.systeme.io/article/935-so-richten-sie-die-paypal-integration'
    }
    case LocaleEnum.FRENCH: {
      return 'https://aide.systeme.io/article/48-comment-connecter-votre-compte-paypal-a-systeme-io'
    }
    case LocaleEnum.JAPANESE: {
      return 'https://help-jp.systeme.io/article/2363-how-to-integrate-paypal-with-systeme-io'
    }
    case LocaleEnum.PORTUGUESE: {
      return 'https://help-pt.systeme.io/article/746-integracao-com-o-paypal'
    }
    case LocaleEnum.SPANISH: {
      return 'https://help-es.systeme.io/article/657-integracion-de-paypal'
    }
    case LocaleEnum.ITALIAN: {
      return 'https://help-it.systeme.io/article/486-integrazione-di-paypal-completo'
    }
    default: {
      return 'https://help.systeme.io/article/132-paypal-integration'
    }
  }
}
